/*
 * @Author: Toy
 * @Date:   2017-07-25 10:58:52
 * @Last Modified by:   Toy
 * @Last Modified time: 2017-08-14 16:06:35
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { getLanguage } from '@/utils/language'

Vue.use(VueI18n)

const i18n = new VueI18n({
	locale: getLanguage(),
	messages: {}
})

export async function setLang(lang) {
	if (!i18n.messages[lang]) {
		try {
			var data = (await import(`@/components/i18n/locals-editor/${lang}.json`)).default
			i18n.setLocaleMessage(lang,data)
		} catch (err) { 
			//
		} finally {
			i18n.locale = getLanguage()
		}
	}
	i18n.locale = lang
}


export default i18n
